module.exports = __webpack_public_path__ + "static/img/12_.652c170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/12_.jpg
// module id = PkLY
// module chunks = 1